import { mapState } from 'vuex';
import preview from "./preview/index.vue";

export default {
    name: 'chats',
    props: {
        
    },

    components : {
        preview
    },

    data : function(){

        return {
            loading : false
        }

    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,

        chats : function(state){
            return this.core.chats.helpers.getChatsForUser(state.userinfo.userinfo.id)
        },

        sorted : function(){
            return _.sortBy(this.chats, (c) => {
                return -(new Date(c.events[0]?.date || c.date || 0))
            })
        }
    }),

    methods : {
        
    },
}